export class MasterDataModel {
    public companyId: number;
    public facilityId: number;
    public kioskId: number;
}
